// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Jewish Worldwide Defense Alliance (JWDA)</p>
    </footer>
  );
}

export default Footer;
